import React from "react";
import { useTranslation } from "react-i18next";

const AlertMessage = ({ showAlert }) => {
  const { t } = useTranslation();

  if (!showAlert) return null;

  return (
    <div className="alert-danger" role="alert">
      {t("groupPage_alert_select_page_name")}
    </div>
  );
};

export default AlertMessage;
